<template>
<div>
  <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
    <el-row type="flex" align="center">
      <span class="root-cause-title mr-r15">관리 대상 선택 </span>
      <w-root-cause-obj-type-filter style="float: left;" ref="objTypeFilter" :managetype-data="managetypeData" :selected-managetype-id="selectedManagetypeId"
        :init-load="true" @filter-change="onFilterChange"/>
    </el-row>
    <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
  </el-row>
  <el-table-wrapper :style="fitHeight ? { height: '100%' } : null" :fit-height="fitHeight" ref="objTable" :data="tableData" :total="total"
    :columns="columns" :show-search-tool="showSearchTool" remote pagination :show-custom-header="showCustomHeader" @condition-change="onConditionChange"
    @select="onSelect" @select-all="onSelectAll">
  </el-table-wrapper>
</div>
</template>

<script>
import { isEmpty, isNil, filter } from 'lodash';
import logicalGroupApi from '@/api/settings/common/logical-group';
import { columnDefault } from '@/constants/table';
import WRootCauseObjTypeFilter from './RootCauseObjTypeFilter';

export default {
  name: 'WRootCausePhysicalObjTable',
  components: {
    WRootCauseObjTypeFilter,
  },
  props: {
    selectedManagetypeId: {
      type: String,
      default: null,
    },
    height: {
      type: String,
    },
    fitHeight: {
      type: Boolean,
    },
    checkedObjList: {
      type: Array,
      default: () => {},
    },
    managetypeData: {
      type: Array,
    },
    vmTemplateFlag: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showSearchTool: false,
      showCustomHeader: true,
      tableData: null,
      originTableData: null,
      total: null,
      columnDefault,
      columns: [],
      filterParams: null,
    };
  },
  watch: {
    managetypeData: {
      handler() {
        this.$refs.objTypeFilter.loadManagetype();
      },
    },
    filterParams: {
      handler(to, from) {
        if (!isEmpty(to)) {
          if (isEmpty(from) || to.params.managetypeId !== from.params.managetypeId || to.params.managetypeKey !== from.params.managetypeKey) {
            // TODO columns를 변경하더라도 label이 변경되지 않는 문제있어 빈 columns을 먼저 주고 관리 구분에 맞는 컬럼을 설정하도록 함.
            // v-for에서 재사용으로 인한 문제로 파악되며 근본적인 해결책을 찾을 경우 해당 로직 수정 필요
            this.columns = [];
            this.$refs.objTable.clearFilter();
            this.$nextTick(() => {
              this.columns = to.columns;
            });
          }
          this.loadData();
        }
      },
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
      this.$refs.objTypeFilter.loadManagetype();
    },
    /**
     * 물리 그룹 관리 대상 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      const tableParams = {
        ...this.filterParams.params,
        ...this.$refs.objTable.getParameter(),
      };
      if (!isNil(this.vmTemplateFlag)) {
        tableParams.vmTemplateFlag = this.vmTemplateFlag;
      }
      logicalGroupApi
        .getPhysicalObjList(tableParams)
        .then((response) => {
          const result = response.data;
          if (!isEmpty(result) && result.success === true && !isEmpty(result.data)) {
            result.data.forEach((row) => {
              const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
              row.checked = !isNil(checkedObj) ? 1 : 0;
            });
            this.tableData = result.data;
            this.total = result.total;
            const originalData = filter(result.data, (item) => item.checked);
            this.originTableData = originalData;
            this.$nextTick(() => {
              this.toggleRowSelection(originalData);
            });
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          // this.managegrpObjData.loading = false;
          this.tableData = [];
          this.total = 0;
        });
    },
    /**
     * 테이블 조건 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onConditionChange() {
      this.loadData();
    },
    /**
     * 테이블 선택 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     */
    onSelect(selection, row) {
      const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
      if (!isNil(checkedObj)) {
        this.checkedObjList.splice(this.checkedObjList.indexOf(checkedObj), 1);
      } else {
        this.checkedObjList.push(row);
      }
    },
    onSelectAll(selection) {
      const tableData = this.tableData;
      tableData.forEach((row) => {
        const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
        if (selection.length > 0) {
          if (isNil(checkedObj)) {
            this.checkedObjList.push(row);
          }
        } else if (selection <= 0) {
          if (!isNil(checkedObj)) {
            this.checkedObjList.splice(this.checkedObjList.indexOf(checkedObj), 1);
          }
        }
      });
    },
    /**
     * 선택된 데이터 배열 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getSelection() {
      return this.$refs.objTable.getTable().selection;
    },
    /**
     * 테이블 행 선택을 토글한다.
     * @author Ju
     * @param  {[type]} rows [description]
     * @return {[type]}      [description]
     */
    toggleRowSelection(rows) {
      rows.forEach((row) => {
        this.$refs.objTable.getTable().toggleRowSelection(row);
      });
    },
    /**
     * 모든 행 선택을 해제한다.
     * @author Ju
     * @return {[type]} [description]
     */
    clearSelection() {
      this.$refs.objTable.getTable().clearSelection();
    },
    setCheckObjTable() {
      if (!isNil(this.tableData)) {
        this.tableData.forEach((row) => {
          const checkedObj = this.checkedObjList.find((obj) => (obj.objId === row.objId));
          row.checked = !isNil(checkedObj) ? 1 : 0;
        });
        const originalData = filter(this.tableData, (item) => item.checked);
        this.$nextTick(() => {
          this.clearSelection();
          this.toggleRowSelection(originalData);
        });
      }
    },
    /**
     * 장비 구분 조건 변경 이벤트 핸들러
     * @author Ju
     * @param  {Object} params 장비 구분 조건 객체
     * @param  {Array} columns 장비 구분 컬럼
     */
    onFilterChange(params, columns) {
      this.filterParams = {
        params,
        columns,
      };
    },
  },
};
</script>

<style scoped>
.root-cause-title {
  float: left;
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #000;
  font-size: 1.063rem;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/RootCauseEventSettings/components/RootCausePhysicalObjTable.vue